export default "__VITE_ASSET___UQ78tWQ__"